import React, { Fragment } from 'react';
import { Placement } from 'react-joyride';

import { Title, Paragraph } from './styles';

const Step1Component = () => {
  return (
    <Fragment>
      <Title>Including a photo? See it in designs</Title>
      <Paragraph>Not picture perfect? Edit your photo when customizing.</Paragraph>
    </Fragment>
  );
};

export default {
  target: '#preview-photo-walkthrough',
  content: <Step1Component />,
  disableBeacon: true,
  nextButtonText: 'Add photo',
  floaterProps: {
    placement: 'left' as Placement,
  },
  showSkipButton: false,
};
